const fileDownloadButtonFormService = {
  title: 'Generar Informe'
};

export default fileDownloadButtonFormService;
